import type { TechMeans, BaseRequest } from './common.interface';

export type ApiInitDisclosureSettingRequest = TechMeans & BaseRequest;

export const InitDisclosureSetting = Symbol('InitDisclosureSetting');

export interface InitDisclosureSetting {
    initDisclosureSetting(data: ApiInitDisclosureSettingRequest): Promise<void>;
}
